module.exports = __webpack_public_path__ + "static/media/1.b979a230.png";